(function () {
    'use strict';
    /*
     * Copyright (c) 2014-16 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .service('LoginSvc', LoginSvc);

    LoginSvc.$inject = ['$resource', 'appConfig', '$rootScope', 'AUTH_EVENTS', 'ObserverService'];

    /**
     * Provides a a service for logging in and out of the server.
     * Do not use <code>new</code> to create an instance. See the example below for how to use the service in a controller.
     * @ngdoc service
     * @name LoginSvc
     * @memberOf ihh-utilities
     * @example
     * // Declaring the LoginSvc service in a controller.
     * myModule.controller('MyCtrl', ['LoginSvc', ..., function(LoginSvc, ...) {
     *    ...
     * }
     */
    function LoginSvc($resource, appConfig, $rootScope, AUTH_EVENTS, ObserverService) {
        var restHost = appConfig.restHost;
        var sessionsResource = $resource(restHost + appConfig.restPath + '/sessions/:id');

        this.login = function(credentials, params, successFn, errorFn) {
            var request = {
                username: credentials.username,
                password: credentials.password
            };

            sessionsResource.save(params, request, function(session) {
                $rootScope.$broadcast(AUTH_EVENTS.loginSuccess, session);

                if (successFn) {
                    successFn(session);
                }
            }, function(err) {
                if (errorFn) {
                    errorFn(err);
                }
            });
        };

        /**
         * @function LoginSvc#logout
         * @description Logs the user out of the application.
         */
        this.logout = function(session) {
            if (session) {
                // Fire and forget, because, really what are we gonna do if it fails?
                sessionsResource.delete({
                    id: session.id
                });
            }

            // Always broadcast this event so that all local login information gets reset and we go to the login page.
            $rootScope.$broadcast(AUTH_EVENTS.logout, session);
            ObserverService.notifyObservers(AUTH_EVENTS.logout, {});
        };
    }
})();